import { render, staticRenderFns } from "./BindForm.vue?vue&type=template&id=37d0810c&scoped=true&"
import script from "./BindForm.vue?vue&type=script&lang=js&"
export * from "./BindForm.vue?vue&type=script&lang=js&"
import style0 from "./BindForm.vue?vue&type=style&index=0&id=37d0810c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0810c",
  null
  
)

export default component.exports